export default {
  props: {
    enableRefresh: {
      type: Boolean,
      default: false,
    },
    dtRefresh: {
      type: Number,
      default: 60000, // every 60 seconds
      validator: (value) => {
        const isValid = value >= 0;
        if (!isValid) {
          console.error('Invalid prop: dtRefresh can NOT be less than 0, received: ', [value, typeof value]);
        }
        return isValid;
      },
    },
  },
  emits: ['refresh'],
  data: () => ({
    refreshing: false,
    refreshTimer: null,
  }),
  mounted() {
    if (this.enableRefresh) {
      this.refreshTimer = setTimeout(this.refresh, this.dtRefresh);
    }
  },
  destroyed() {
    return this.refreshClear();
  },
  methods: {
    refresh() {
      if (!this.refreshing) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(this.refresh, this.dtRefresh);
        /** If table has selected rows, postpon refresh */
        if (this.selectedRows.length) return null;

        this.refreshing = true;
        this.$emit('refresh');
        return Promise.resolve(typeof this.updateHandler === 'function' ? this.updateHandler() : null)
          .catch(err => console.error(err.message))
          .finally(() => {
            this.refreshing = false;
          });
      }
    },
    refreshClear() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
  }
}